function localPhoneNumberFilter(CompanyStoreService, ValidatorService) {
    'ngInject';

    return function (phone_number, country_code) {

        if (!phone_number) {
            return;
        }

        if (!country_code) {
            ({country_code} = CompanyStoreService);
        }

        switch (country_code) {
            case 'gb':
                return phone_number.replace(/^(\+44 \(0\)|\S{0})/, '0');
            case 'us':
                return phone_number.replace(ValidatorService.us_phone_number, '($1) $2 $3');
            default:
                return phone_number;
        }
    };
}

/**
 * @ngdoc filter
 * @name local_phone_number
 * @kind function
 *
 * @description
 * Formats a phone number using provided country code. If no country code is passed in, the country of the current company is used.
 *
 * @param {string} phone_number The phone number to format
 * @param {string} country_code (Optional) The country code in Alpha-2 ISO-3166 format
 * @returns {string} Formatted phone number
 *
 *

 <example module="localPhoneNumberExample">
 <file name="index.html">
 <script>
 angular.module('localPhoneNumberExample', [])
 .controller('ExampleController', ['$scope', function($scope) {
 $scope.number = "+44 7877 123456";
 }]);
 </script>
 <div ng-controller="ExampleController">
 <span>Phone Number: {{number | local_phone_number}}</span>
 </div>
 </file>
 </example>
 */
angular
    .module('BB')
    .filter('local_phone_number', localPhoneNumberFilter);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_filters/local_phone_number.filter.js